<template>
  <div class="ScheduleWidget lxn-w100 lxn-float-left lxn-border-round lxn-overflow-hidden">
    <div class="ScheduleWidget-header lxn-w100" :style="headerColor">
      <div class="ScheduleWidget-header-text lxn-text lxn-overflow-hidden" :class="[$store.getters.language.floatClass, $store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
        {{$store.getters.language.texts.DashBoard_scehdule}}
      </div>
    </div>
    <div class="ScheduleWidget-body lxn-w100">
      <div class="ScheduleWidget-left lxn-float-left">
        <emitting-analog-clock id='main-clock' :size='100' :showDigital="false" :smooth="false" shape="square" :shadowing="false" backgroundColor="#FFFFFF" color="#53636C"></emitting-analog-clock>
      </div>
      <div class="ScheduleWidget-right lxn-float-left">
        <CalendarWidget />
      </div>
    </div>
  </div>
</template>

<script>

import EmittingAnalogClock from '@/components/widgets/EmittingAnalogClock.vue'
import CalendarWidget from '@/components/widgets/CalendarWidget.vue'

export default {
  name: 'ScheduleWidget',
  props: {
    index: Number,
    editing: Boolean
  },
  components: {
    EmittingAnalogClock,
    CalendarWidget
  },
  data: function () {
    return {
    }
  },
  computed: {
    headerColor: function () {
      return "background-color: " + this.$store.state.themeSecondaryColors[5] + ";"
    },
  },
  methods: {
  }
}
</script>

<style>
  .ScheduleWidget {
    height: 160px;
    margin-bottom: 10px;
  }
  .ScheduleWidget-header {
    height: 30px;
  }
  .ScheduleWidget-body {
    padding-top: 10px;
    height: 130px;
    background-color: #ECECEC;
  }
  .ScheduleWidget-header-text {
    padding-left: 10px;
    padding-right: 10px;
    height: 30px;
    line-height: 30px;
    color: #000000;
  }
  .ScheduleWidget-right {
    width: 50%;
  }
  .ScheduleWidget-left {
    width: 50%;
  }
</style>
